import PageDependencies from "../../../Feature/PageDependencies";

const ConstructionDataTable = (props)=>{
  const debug = props.debug === undefined ? false : props.debug;
    const { 
        tryCatchFinally,
        stringCoding,
        getData,
        guid,
        toastPrint,
        useNavigate,
        Fragment, 
        useState,
        getLatestStateValue,
        dataExtension,
        ServerSideDataTable,
        AppLoading,
        ModalDatatableItem,
    } = PageDependencies();
    const emptyGuid = guid.emptyGuid();
    const nav = useNavigate();
    const [modal, setModal] = useState({
        isOpen: false,
        title: "",
        message: "",
        comfirmButtonStyle: "",
        comfirmButtonText: "Comfirm",
        handleComfirm: () => {},
    });
    const [loading, setLoading] = useState({isLoading:false,text:""});
    const [data, setData] = useState([]);
    const tableId = props.tableId;
    const tableReload = props.tableReload;
    const redirectUrl = props.redirectUrl;
    const setTableReload = props.setTableReload;
    const extraPostModel = props.extraPostModel;
    const setSelectedIds = props.setSelectedIds;
    const designVariationVersionName = extraPostModel.designVariationVersionName;
    const developmentId = extraPostModel.developmentId;
    const projectId = extraPostModel.projectId;
    const designVariationId = extraPostModel.designVariationId;
    const columns = [
        { name: "name", text: "Name", width: "50%" },
        { name: "type", text: "Type", width: "25%" },
        { name: "area", text: "Area", width: "25%" }
      ];

    const copiedItem = props.copiedItem;
    const setCopiedItem = props.setCopiedItem;

    const generateBaseUrl = (type, isMultiple = false)=>{
        const multiple =  isMultiple ? "Multiple" : "";
        return "/ConstructionAssessor/Detail" + multiple + "/" + type + "/" + designVariationVersionName + "/" + developmentId + "/" + projectId + "/" + designVariationId + "/"  + emptyGuid + "/" + stringCoding.encode(redirectUrl);
    }

    const handleCopy = () => {
      const selectedItemDic = dataExtension.getSelectedRowsDic(data, "type");
      setCopiedItem(selectedItemDic);
    }

    const handlePaste = async () => {
      await tryCatchFinally.asyncProcess(async () => {
          // const selectedItemDic = dataExtension.getSelectedRowsDic(data, "type");
          setLoading({ isLoading: true, text: "Duplicating constructions" });
          const selectResponse = await getData.processPost(
              true,
              "api/Construction/Accessor/CopyConstructions",
              { selectedItemDic: copiedItem, designVariationVersionName: designVariationVersionName, projectId: projectId, developmentId: developmentId}
          );
          toastPrint.printResponse(selectResponse);
          setTableReload(guid.newGuid());
      }, setLoading);
  }

    const contextMenu = {
      items: {
        new: {
          name: "New",
          icon: "add",
          items: {
            createCeiling: {
              name: "Ceiling",
              icon: "",
              url: generateBaseUrl("Ceiling", false),
              isNavOption: true
            },
            createFloor: {
              name: "Floor",
              icon: "",
              url: generateBaseUrl("Floor", false),
              isNavOption: true
            },
            createDoor: {
              name: "Door",
              icon: "",
              url: generateBaseUrl("Door", false),
              isNavOption: true
            },
            createExternalWall: {
              name: "External Wall",
              icon: "",
              url: generateBaseUrl("ExternalWall", false),
              isNavOption: true
            },
            createInternalWall: {
                name: "Internal Wall",
                icon: "",
                url: generateBaseUrl("InternalWall", false),
                isNavOption: true
              },
              createRoof: {
                name: "Roof",
                icon: "",
                url: generateBaseUrl("Roof", false),
                isNavOption: true
              },
              createRoofWindow: {
                name: "Roof Window",
                icon: "",
                url: generateBaseUrl("RoofWindow", false),
                isNavOption: true
              },
              createWindow: {
                name: "Window",
                icon: "",
                url: generateBaseUrl("Window", false),
                isNavOption: true
              },
              createSkylight: {
                name: "Skylight",
                icon: "",
                url: generateBaseUrl("Skylight", false),
                isNavOption: true
              },
          },
        },
        separator: "---------",
        edit: {
            name: "Edit",
            icon: "edit",
            defaultAction: false,
              disabled: function () {
              return dataExtension.getSelectedRowDataIds(data).length !== 1;
            },
          },
          delete: {
            name: "Delete",
            icon: "delete",
            url: "",
            defaultAction: false,
            disabled: function () {
              return dataExtension.getSelectedRowDataIds(data).length === 0;
            },
          },
          duplicate: {
            name: "Duplicate",
            icon: "copy",
            url: "",
            defaultAction: false,
            disabled: function () {
              return dataExtension.getSelectedRowDataIds(data).length === 0;
            },
          },
          copy: {
            name: "Copy",
            icon: "copy",
            url: "",
            defaultAction: false,
            disabled: function () {
              return dataExtension.getSelectedRowDataIds(data).length === 0;
            },
          },
          paste: {
            name: "Paste",
            icon: "paste",
            url: "",
            defaultAction: false,
            disabled: function () {
              return getLatestStateValue(setCopiedItem).length === 0;
            },
          }
      },
      callBack: (
        contextMenuCallBackKey,
        contextMenuCallBackElement,
        contextMenuCallBackTableRoadData,
        localtion
      ) => {
        if (contextMenuCallBackKey === "edit") {
          const selectedZoneIds = dataExtension.getSelectedRowDataIds(data);
          if(selectedZoneIds.length == 1){
              nav("/ConstructionAssessor/Detail/" + dataExtension.getSelectedRows(data)[0].type.replace(" ", "").replace("/", "") + "/" + designVariationVersionName + "/" + developmentId + "/"+ projectId + "/" + designVariationId + "/" + selectedZoneIds[0] + "/" + stringCoding.encode(redirectUrl));
          }else{
             nav("/ConstructionAssessor/MultipleDetail/" + designVariationVersionName + "/" + developmentId + "/" + projectId + "/" + designVariationId + "/" + stringCoding.encodeObject(selectedZoneIds));
          }
        }
          if (contextMenuCallBackKey === "delete") {
            setModal({
                ...modal,
                isOpen: true,
                title: "Delete constructions",
                message:
                    "Are you sure you want to delete " +
                    dataExtension.getSelectedRowDataIds(data).length +
                    " selected construction(s)?",
                comfirmButtonStyle: "danger",
                comfirmButtonText: "Confirm to delete",
                handleComfirm: handleDeleteComfirm,
            });
        }
          if (contextMenuCallBackKey === "duplicate") {
             setModal({
                ...modal,
                isOpen: true,
                title: "Duplicate constructions",
                message:
                    "Are you sure you want to duplicate " +
                    dataExtension.getSelectedRowDataIds(data).length +
                    " selected construction(s)?",
                comfirmButtonStyle: "primary",
                comfirmButtonText: "Confirm to duplicate",
                handleComfirm: handleDuplicatedComfirm,
            });
        }
        if (contextMenuCallBackKey === "copy") {
          handleCopy();
        }
        if (contextMenuCallBackKey === "paste") {
          handlePaste();
        }
      },
    };

    const actionOnDoubleClickRow = (model, newData) =>{
      nav("/ConstructionAssessor/Detail/" + model.type.replace(" ","").replace("/","") + "/" + designVariationVersionName + "/" + developmentId + "/" + projectId + "/" + designVariationId + "/" + model.id + "/" + stringCoding.encode(redirectUrl)) ;
    }

    const handleDeleteComfirm = async () => {
        await tryCatchFinally.asyncProcess(async () => {
            const selectedItemDic = dataExtension.getSelectedRowsDic(data, "type");
            setLoading({ isLoading: true, text: "Deleting constructions" });
            const selectResponse = await getData.processPost(
                true,
                "api/Construction/Accessor/DeleteConstructions",
                { selectedItemDic: selectedItemDic, designVariationVersionName: designVariationVersionName, projectId: projectId, developmentId: developmentId }
            );
            toastPrint.printResponse(selectResponse);
            setTableReload(guid.newGuid());
        }, setLoading);
    }

    const handleDuplicatedComfirm = async () => {
        await tryCatchFinally.asyncProcess(async () => {
            const selectedItemDic = dataExtension.getSelectedRowsDic(data, "type");
            setLoading({ isLoading: true, text: "Duplicating constructions" });
            const selectResponse = await getData.processPost(
                true,
                "api/Construction/Accessor/CopyConstructions",
                { selectedItemDic: selectedItemDic, designVariationVersionName: designVariationVersionName, projectId: projectId, developmentId: developmentId }
            );
            toastPrint.printResponse(selectResponse);
            setTableReload(guid.newGuid());
        }, setLoading);
    }

    return(<Fragment>
        {debug && <p>Selected items: {JSON.stringify(dataExtension.getSelectedRowDataIds(data))}</p>}
        {debug && <p>Copied items: {JSON.stringify(copiedItem)}</p>}
        {loading.isLoading && (<AppLoading active><div>{loading.text}</div></AppLoading>)}
            <ModalDatatableItem
                modal={modal}
                setModal={setModal}
            ></ModalDatatableItem>
           <ServerSideDataTable
                id={tableId}
                location="Constructions"
                data={data}
                setData={setData}
                reload={tableReload}
                columns={columns}
                actionOnDoubleClickRow = {actionOnDoubleClickRow}
                allowSelect
                allowSelectMultiple
                dataSource={{ isAuth: true, url: "api/Construction/Accessor" }}
                contextMenu={contextMenu}
                extraPostModel={extraPostModel}
                setSelectedItemIds = {setSelectedIds}
            >
            </ServerSideDataTable>
    </Fragment>);
}
export default ConstructionDataTable;